module.exports = {"TXTACL_Close":{"id":"TXTACL_Close","defaultMessage":"Κλείσιμο","flags":["TRACK"],"track":"Close"}}